<div class="layout-sidebar" [class.sidebar-collapsed]="layoutService.state.sidebarCollapsed">
  <div class="sidebar-header">
    <a class="sidebar-brand" routerLink="/dashboard">
      <img
        [src]="layoutService.state.sidebarCollapsed ? 'assets/icons/globot-icon.svg' : 'assets/icons/globot.svg'"
        alt="Globot"
        class="sidebar-brand-icon"
      />
    </a>
  </div>
  <globot-workspace-selector [collapsed]="layoutService.state.sidebarCollapsed"></globot-workspace-selector>
  <div class="sidebar-content">
    <globot-menu></globot-menu>
  </div>
  <div class="sidebar-footer">
    <ul class="sidebar-footer-menu">
      <li *ngIf="isInsideBot">
        <a routerLink="/dashboard/bot" class="sidebar-footer-item">
          <span class="material-symbols-outlined sidebar-footer-icon">smart_toy</span>
          <span class="sidebar-footer-label" *ngIf="!layoutService.state.sidebarCollapsed">Mis asistentes</span>
        </a>
      </li>
      <li>
        <a (click)="openHelp()" class="sidebar-footer-item">
          <span class="material-symbols-outlined sidebar-footer-icon">help_outline</span>
          <span class="sidebar-footer-label" *ngIf="!layoutService.state.sidebarCollapsed">Ayuda</span>
        </a>
      </li>
      <li>
        <a routerLink="/dashboard/edit-user" routerLinkActive="active-route" class="sidebar-footer-item">
          <span class="material-symbols-outlined sidebar-footer-icon">person</span>
          <span class="sidebar-footer-label" *ngIf="!layoutService.state.sidebarCollapsed">Mi cuenta</span>
        </a>
      </li>
      <li>
        <a (click)="logout()" class="sidebar-footer-item sidebar-footer-item--logout">
          <span class="material-symbols-outlined sidebar-footer-icon">logout</span>
          <span class="sidebar-footer-label" *ngIf="!layoutService.state.sidebarCollapsed">Cerrar sesión</span>
        </a>
      </li>
    </ul>
  </div>
</div>
